import { createReducer } from 'redux-starter-kit';
import i18next from 'i18next';
import { MonitoringApi } from '../../../_helpers/service';
import { handleError } from '../../../utils/handleError';
import Dict from '../../../utils/Dict';

/**
 * Constants
 */
export const reportVoucherHolders = 'monitoringReportVoucherHolders';

const LOADING_TABLE = `${reportVoucherHolders}/LOADING_TABLE`;
const TABLE_DATA = `${reportVoucherHolders}/TABLE_DATA`;
const CLEAR_STATE = `${reportVoucherHolders}/CLEAR_STATE`;

/**
 * Initial state
 */
const initialState = {
  loadingTable: false,
  tableData: {
    content: [],
    totalElements: 0
  },
  pageNumber: 1
};

/**
 * Reducer
 */
export default createReducer(initialState, {
  [LOADING_TABLE]: (state, action) => {
    state.loadingTable = action.payload;
  },
  [TABLE_DATA]: (state, action) => {
    state.tableData = {
      content:
        action.pageNumber === 1
          ? action.data
          : [...state.tableData.content, ...action.data],
      totalElements: action.totalElements
    };
    state.pageNumber = action.pageNumber;
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */
export const clearState = () => ({ type: CLEAR_STATE });

export const loadDataReportVoucherHolders = (filter, type = '') => async dispatch => {
  try {
    dispatch({ type: LOADING_TABLE, payload: true });

    const params = new URLSearchParams();

    Object.entries(filter).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        if (Array.isArray(value)) {
          params.append(key, value.join(','));
        } else {
          params.append(key, value);
        }
      }
    });
    if (type === 'NOT_SELECT_PO') {
      params.set('appStatus', 'ASSIGN_VOUCHER');
    }

    if (type === 'NOT_ACCEPT_VOUCHER') {
      params.set('appStatus', 'ANNULLED,REJECTED_VOUCHER');
    }

    let response;
    if (type === 'NOT_SELECT_PO' || type === 'NOT_ACCEPT_VOUCHER') {
      response = await MonitoringApi.loadReportsVoucherHoldersNotSelectedPO(params.toString());
    } else {
      response = await MonitoringApi.loadReportsVoucherHolders(params.toString());
    }

    const { data } = response;

    const content = [];
    for (let item of data.content) {
      const passport = {};
      if (Array.isArray(item.passportValues)) {
        for (const p of item.passportValues) {
          passport[p.code] = p.value;
        }
      }
      let queuedType = item.queuedType
        ? await Dict.item('gu_queued_type', item.queuedType || '')
        : '';
      let appStatusWeb = item.status
        ? await Dict.item('waiting_list_status', item.status || '')
        : '';
      // let queuedRegion = item.queuedRegion
      //   ? await Dict.item('60', item.queuedRegion || '')
      //   : '';
      let ageGroup = item.ageGroup
        ? await Dict.item('gu_age_group', item.ageGroup || '')
        : '';

      content.push({
        ...item,
        ...passport,
        queuedType,
        appStatusWebStatus: appStatusWeb,
        // queuedRegion,
        ageGroup
      });
    }

    dispatch({
      type: TABLE_DATA,
      data: content,
      pageNumber: data.pageNumber,
      totalElements: data.totalElements
    });
  } catch (error) {
    handleError(error, i18next.t('monitoringDucks_errorLoadTable'));
  } finally {
    dispatch({ type: LOADING_TABLE, payload: false });
  }
};

export const exportReportsVoucherHolder = reportVoucherHoldersType => async () => {
  try {
    let response;
    let fileNameSuffix = '';

    if (reportVoucherHoldersType === 'WAITING_PO') {
      response = await MonitoringApi.getReportsVoucherHoldersExcel();
      fileNameSuffix = '';
    }

    if (reportVoucherHoldersType === 'NOT_SELECT_PO') {
      const params = new URLSearchParams();
      params.append('appStatus', 'ASSIGN_VOUCHER');
      response = await MonitoringApi.getReportsVoucherHoldersExcelNotSelectedPO(params.toString());
      fileNameSuffix = '_assign_voucher';
    }

    if (reportVoucherHoldersType === 'NOT_ACCEPT_VOUCHER') {
      const params = new URLSearchParams();
      params.append('appStatus', 'ANNULLED,REJECTED_VOUCHER');
      response = await MonitoringApi.getReportsVoucherHoldersExcelNotSelectedPO(params.toString());
      fileNameSuffix = '_annulled_rejected_voucher';
    }

    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `reports_voucher_holders${fileNameSuffix}_${new Date().toISOString().split('T')[0]}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode && link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    handleError(error, i18next.t('monitoringDucks_errorExportTable'));
  }
};